<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">UPDATE TICKET SPREAD</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form  @submit.prevent="">
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="inputLast">SPREAD</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            placeholder="Spread" 
                            v-model="holding.ticketSpread" 
                        >
                    </div>
                    <div class="form-group col-md-6 required">
                    </div>
                </div>      
            </form>   
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button v-if="moduleName == 'IMS'" @click="updateTicketSpreadIms()" type="button" class="btn btn-primary" >UPDATE</button>
                <button v-if="moduleName == 'BIDACCUMULATOR'" @click="updateTicketSpreadBidWanted()" type="button" class="btn btn-primary" >UPDATE</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'createbidwanted',
    props: ['holding','moduleName'],
    components :{
    },
    data() {
        return {
            
           
        }

    },
    methods:{
        updateTicketSpreadIms(){
            let data = {
                id : this.holding.id,
                ticketSpread : this.holding.ticketSpread
            }
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(config.baseUrlBidSide + "/offer/ticket-spread",data,auth)
                .then(() => {
                    this.loading = false;              
                    this.$alert("Ticket spread updated","","success");
                    this.$emit('close'); 
                })
                .catch(() => {
                    this.loading = false;              
                });
        },
        updateTicketSpreadBidWanted(){
            let data = {
                id : this.holding.id,
                ticketSpread : this.holding.ticketSpread
            }
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(config.baseUrlBidSide + "/bidwanted/ticket-spread",data,auth)
                .then(() => {
                    this.loading = false;              
                    this.$alert("Ticket spread updated","","success");
                    this.$emit('close'); 
                })
                .catch(() => {
                    this.loading = false;              
                });
        }

    },
    mounted(){
        console.log(this.holding)
    }
};
</script>